import React from 'react'

import { Row, Container, Table } from 'react-bootstrap'
import { useLocation, useParams } from 'react-router-dom'
import PersianText from '../components/PersianText';
import { BASE_URL } from '../constants/urlConstants';


function PasargadPayResultScreen() {
    const { id, referenceNumber, trackId } = useParams()
    const location = useLocation();
    // دریافت Query String به صورت شیء
    const queryParams = new URLSearchParams(location.search);
    // دسترسی به مقادیر خاص از Query String
    const dbId = queryParams.get('db'); // مقدار پارامتر 'db'



    return (
        <div>
            <Container>
                <Row className='mt-3'>
                {trackId=="None" ?
                                <img
                                src={`${BASE_URL}/public/images/logo/danger.png`}
                                  alt="danger"
                                  style={{
                                    width: "100px", // عرض عکس
                                    height: "100px", // ارتفاع عکس
                                    padding: "0",
                                    objectFit: 'fill',
                                  }}>
                                   </img> 
                                :
                                <img
                 src={`${BASE_URL}/public/images/logo/tik.png`}
                   alt="tik"
                   style={{
                    width: "150px", // عرض عکس
                    height: "150px", // ارتفاع عکس
                    padding: "0",
                    objectFit: 'fill',
                  }}>
                    </img>}
                
                </Row>
                <Row>
                    <Table className="table table-sm table-bordered table-warning table-striped table-hover" id="table-to-print">
                        <thead>
                        </thead>
                        <tbody>
                            <tr>
                                <td className='table-warning text-danger'>کد سفارش</td>
                                <td className='table-warning'><PersianText> {id}</PersianText></td>
                            </tr>
                            <tr>
                                <td className='table-warning text-danger'>وضعیت</td>
                                <td className='table-warning'> {trackId=="None" ?
                                "عملیات ناموفق" : "عملیات موفق"}</td>
                            </tr>
                            <tr>
                                <td className='table-warning text-danger'> کد رهگیری پرداخت</td>
                                <td className='table-warning'><PersianText>{trackId ? trackId : ""}</PersianText></td>
                            </tr>
                            <tr>
                                <td className='table-warning text-danger'>شناسه پرداخت</td>
                                <td className='table-warning'> <PersianText>{referenceNumber}</PersianText></td>
                            </tr>





                        </tbody>
                    </Table>
                </Row>
            </Container>
        </div>
    )
}

export default PasargadPayResultScreen